<template>
    <div >

        <v-layout>
            <!--<v-flex xs6>-->
                <!--<v-chip text-color="white" label color="primary">-->
                    <!--Projet {{libProjet}}  / Chef projet {{chefProjet}}  /  Chantier {{libChantier}}  /  Chef chantier {{ chefChantier }}-->
                <!--</v-chip>-->
            <!--</v-flex>-->
        </v-layout>
           <v-layout row>
               <v-flex xs2 class="mr-2" >
                   <v-card>
                       <v-toolbar color="light-blue" dark>
                           <v-toolbar-title>Details travaux</v-toolbar-title>
                       </v-toolbar>

                       <v-list two-line subheader dense>

                           <v-list-tile>

                               <v-list-tile-content>
                                   <v-list-tile-title>Projet</v-list-tile-title>
                                   <v-list-tile-sub-title>{{libProjet}}</v-list-tile-sub-title>
                               </v-list-tile-content>
                           </v-list-tile>

                           <v-list-tile>
                               <v-list-tile-content>
                                   <v-list-tile-title>Chef projet </v-list-tile-title>
                                   <v-list-tile-sub-title>{{chefProjet}}</v-list-tile-sub-title>
                               </v-list-tile-content>
                           </v-list-tile>

                           <v-list-tile>
                               <v-list-tile-content>
                                   <v-list-tile-title>Chantier </v-list-tile-title>
                                   <v-list-tile-sub-title>{{libChantier}}</v-list-tile-sub-title>
                               </v-list-tile-content>
                           </v-list-tile>

                           <v-list-tile>
                               <v-list-tile-content>
                                   <v-list-tile-title>Chef chantier  </v-list-tile-title>
                                   <v-list-tile-sub-title>{{ chefChantier }}</v-list-tile-sub-title>
                               </v-list-tile-content>
                           </v-list-tile>


                           <v-divider></v-divider>

                           <v-list-tile v-if="selectedTask">
                               <v-list-tile-content>
                                   <v-list-tile-title>Travaux</v-list-tile-title>
                                   <v-list-tile-sub-title>{{selectedTask.text}}</v-list-tile-sub-title>
                               </v-list-tile-content>
                           </v-list-tile>

                           <v-list-tile v-if="selectedTask">
                               <v-list-tile-content>
                                   <v-list-tile-title>Chef des travaux</v-list-tile-title>
                                   <v-list-tile-sub-title>{{selectedTask.chefTravaux}}</v-list-tile-sub-title>
                               </v-list-tile-content>
                           </v-list-tile>



                           <v-list-tile v-if="selectedTask">
                               <v-list-tile-content>
                                   <v-list-tile-title>Progression</v-list-tile-title>
                                   <v-list-tile-sub-title>{{selectedTask.progress|toPercent}}%</v-list-tile-sub-title>
                               </v-list-tile-content>
                           </v-list-tile>

                           <v-list-tile v-if="selectedTask">
                               <v-list-tile-content>
                                   <v-list-tile-title>Date initiale</v-list-tile-title>
                                   <v-list-tile-sub-title>{{ selectedTask.start_date |  moment("dddd, MMMM Do YYYY") }}</v-list-tile-sub-title>
                               </v-list-tile-content>
                           </v-list-tile>

                           <v-list-tile v-if="selectedTask">
                               <v-list-tile-content>
                                   <v-list-tile-title>Date fin</v-list-tile-title>
                                   <v-list-tile-sub-title>{{selectedTask.end_date |  moment("dddd, MMMM Do YYYY") }}</v-list-tile-sub-title>
                               </v-list-tile-content>
                           </v-list-tile>


                       </v-list>
                   </v-card>
               </v-flex>
               <v-flex xs10>
                   <gantt :tasks="tasks"  @task-selected="selectTask"></gantt>
               </v-flex>


           </v-layout>
    </div>
</template>





<script>

    import Loading from '@/components/Loading';
    import Gantt from '@/components/calendrier/Gantt';

    export default {
        components: {Loading,Gantt},
        name: "planning",
        data() {
            return {
                //data general
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                loading: false,
                tasks: this.$route.params.tasks,
                idChantier: this.$route.params.id,
                libChantier: this.$route.params.libChantier,
                chefChantier: this.$route.params.chefChantier,
                libProjet: this.$route.params.libProjet,
                chefProjet: this.$route.params.chefProjet,
                selectedTask: null,

            }
        },
        computed: {
        },
        filters: {
            toPercent (val) {
                if(!val) return '0'
                return Math.round((+val) * 100)
            },
            niceDate (obj){
                return '${obj.getFullYear()} / ${obj.getMonth()} / ${obj.getDate()}'
            }
        },

        methods: {
            selectTask: function(task){
                this.selectedTask = task
            }
        },


        mounted()
        {

            console.log("params")
            console.log(this.$route.params )

        }

    };
</script>





// WEBPACK FOOTER //
// src/components/calendrier/Planning.vue